import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import debounce from 'lodash/debounce';
import { EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { addAnalytics } from './utils';
var mergedNonErrorFallbackState = {};

/**
 * Merges a new state into the existing merged state, maintaining the maximum count for each key.
 * @param {Object} newState - New state to merge.
 */
export var mergeNonErrorFallbackState = function mergeNonErrorFallbackState(newState) {
  for (var _i = 0, _Object$entries = Object.entries(newState); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (mergedNonErrorFallbackState[key] === undefined) {
      mergedNonErrorFallbackState[key] = value;
    } else {
      mergedNonErrorFallbackState[key] = Math.max(mergedNonErrorFallbackState[key], value);
    }
  }
};

/**
 * Dispatches an analytics event with the current merged state.
 * sliceOrNodeToMarkdown is used in multiples places, and we don't want to send multiple analytics events
 * for the same nonErrorFallbackState, so we debounce it.
 *
 * We also want to merge the nonErrorFallbackState with the existing state
 * @param {EditorView} editorView - The editor view instance.
 */
export var dispatchNonErrorFallbackStateAnalyticsEvent = function dispatchNonErrorFallbackStateAnalyticsEvent(editorView) {
  var tr = addAnalytics({
    editorState: editorView.state,
    tr: editorView.state.tr,
    payload: {
      action: 'nonErrorFallback',
      actionSubject: 'editorPluginAI',
      actionSubjectId: 'markdownSerializer',
      attributes: {
        nonErrorFallbackState: mergedNonErrorFallbackState
      },
      eventType: EVENT_TYPE.OPERATIONAL
    }
  });
  tr.setMeta('addToHistory', false);
  editorView.dispatch(tr);
  // Reset the merged state
  mergedNonErrorFallbackState = {};
};
export var debounceDispatchNonErrorFallbackStateAnalyticsEvent = debounce(dispatchNonErrorFallbackStateAnalyticsEvent, 500);